import { Header } from '@components/layout/components/Header'
import { Menu } from '@components/layout/components/Menu'
import { useGetMe } from '@features/auth/hooks/useGetMe'
import { useIsTablet } from '@hooks/useBreakpoints'
import Person from '@mui/icons-material/Person'
import { paperClasses } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import Typography from '@mui/material/Typography/Typography'
import type { ReactNode } from 'react'
import { useState } from 'react'

interface LayoutProps {
  children?: ReactNode
}

const DRAWER_WIDTH = 300

export function Layout({ children }: LayoutProps) {
  const isTablet = useIsTablet()
  const [isOpenMenu, setIsOpenMenu] = useState(!isTablet)
  const { data } = useGetMe()

  return (
    <>
      <Box
        display="grid"
        gridTemplateRows="auto auto 1fr auto auto"
        sx={{
          height: '100vh',
          width: `calc(100% - ${isOpenMenu && !isTablet ? DRAWER_WIDTH : 0}px)`,
          background: (t) => t.palette.background.paper,
          ml: `${isOpenMenu && !isTablet ? DRAWER_WIDTH : 0}px`,
          transition: '0.3s all',
        }}
      >
        <Box sx={{ pb: 4 }}>
          <Header
            toggleMenu={setIsOpenMenu}
            isOpenMenu={isOpenMenu}
          />
        </Box>
        <Divider />
        <Box
          sx={{
            height: '100%',
            maxHeight: '100vh',
            overflow: 'auto',
            background: (theme) => theme.palette.background.default,
            p: 4,
          }}
        >
          {children}
        </Box>
      </Box>
      <Drawer
        variant={isTablet ? 'temporary' : 'permanent'}
        open={isOpenMenu}
        onClose={() => {
          setIsOpenMenu(false)
        }}
        sx={{
          [`& > .${paperClasses.root}`]: {
            width: `${isOpenMenu ? DRAWER_WIDTH : 0}px`,
            border: 'none',
            transition: '0.3s all',
            boxShadow: (theme) => theme.shadows[3],
            opacity: isOpenMenu ? 1 : 0,
            zIndex: 0,
          },
        }}
      >
        <AppBar
          position="static"
          sx={{
            height: 50,
            width: '100%',
            border: 'none',
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box
            display="grid"
            gridTemplateColumns="auto 1fr"
            gap={1}
            alignItems="center"
            height="100%"
            px={1}
          >
            <Avatar sx={{ width: 30, height: 30 }}>
              <Person />
            </Avatar>
            <Typography>{data?.full_name ?? data?.username}</Typography>
          </Box>
        </AppBar>

        <Box sx={{ overflow: 'auto' }}>
          <Menu />
        </Box>
      </Drawer>
    </>
  )
}
